export default __webpack_public_path__ + "static/media/herbal.a760ca65.jpg";